import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('calling-remote-app');
export const OPEN_REMOTE = 'open-remote';
export const INSTALLED_CALLING_SETTINGS_MIGRATION_FAILED = 'installed-calling-settings-migration-failed';
export const SELECTED_CALL_PROVIDER_MIGRATION_FAILED = 'selected-call-provider-migration-failed';